import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Animate, AnimateKeyframes, AnimateGroup } from 'react-simple-animate';
import Tablet from './tablet.jsx';

export default class ThisDriversArchivedTablets extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      url: props.url || '/api/v1/portal/drivers/tablets',
      tabletAccountId: props.tabletAccountId || null,
    };
  }

  componentDidMount() {
    var that = this;
    $.ajax({
      url: '/api/v1/portal/drivers/tablets/'+
      this.state.tabletAccountId+'/archived',
      method: 'GET',
      data: {api_token: window.api_token},
      cache: false
    })
    .done(function(tabletsJson) {
      that.setState({
        tablets: tabletsJson,
        isLoading: false
      });
    });
  }

  render() {
    var Tablets = [];

    if (this.state.tablets && this.state.tablets.length > 0) {
      this.state.tablets.forEach(function(i) {
          Tablets.push(<Tablet key={'tablet-'+i.id} data={i} />);
        });
    }
    return (
        <div>
            <div className="row tablets-table-header">
                <div className="col-md-3">
                    description
                </div>
                <div className="col-md-3">
                    reference
                </div>
                <div className="col-md-2">
                    amounts
                </div>
                <div className="col-md-2">
                    frequency
                </div>
                <div className="col-md-2">
                    details
                </div>
            </div>
            {Tablets}
        </div>
    );
  }
}
